import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteAnswer = async (answerId) => {
	try {
		await client.delete(`${uri}/item/${answerId}`, {
			headers: authHeader(),
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить вариант ответа, попробуйте позже");
	}
};

export default deleteAnswer;
